import React, { useState, useEffect } from 'react'
import { Table, IconButton, Icon, Panel, ButtonGroup, Row, Col, Dropdown } from 'rsuite'
// import pathname from '../../constants/pathname'
// import { useHistory } from 'react-router-dom'
import { budgetFormat } from '../../utils/formatterUtil'
// import EditButton from '../../components/buttons/editButton/EditButton'
import ConfirmWidget from '../confirm/ConfirmWidget'
import ViewButton from '../../components/buttons/viewButton/ViewButton'
import SaveButton from '../../components/buttons/saveButton/SaveButton'

export default function ProjectCommentRecordTable({
  schema,
  data,
  loading,
  onDelete,
  onSelect,
  isViewMode,
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  // const history = useHistory()
  const [tableData, setTableData] = useState([])
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [deleteObj, setDeleteObj] = useState({})

  // const fs = localStorage.getItem('fontSize')
  // const styleHeaderCell = { whiteSpace: 'normal', wordBreak: 'break-word' }

  useEffect(() => {
    setTableData(data?.values || [])
  }, [schema])

  return (
    <>
      <Table
        wordWrap
        rowHeight={60}
        minHeight={350}
        autoHeight
        loading={loading}
        data={tableData || []}
      >
        {/* <Column width={70} align="center">
          <HeaderCell>ลำดับ</HeaderCell>
          <Cell>
            {(_, index) => {
              return index + 1
            }}
          </Cell>
        </Column> */}

        <Column width={130} align={'left'}>
          <HeaderCell>วันที่</HeaderCell>
          <Cell dataKey="dateFollow" />
        </Column>
        <Column minWidth={250} align={'left'} flexGrow={2}>
          <HeaderCell>สรุปความเห็นโครงการและรายงานความก้าวหน้าโครงการ</HeaderCell>
          <Cell dataKey="notesInput" />
        </Column>
        <Column minWidth={180} align={'left'} flexGrow={1}>
          <HeaderCell>ผู้ให้ความเห็น</HeaderCell>
          <Cell dataKey="commentator" />
        </Column>
      </Table>

      {/* <ConfirmWidget
        title={`ยืนยันการลบรายการ`}
        show={isShowConfirm}
        detail={`ยืนยันการลบ`}
        onCancle={() => {
          setIsShowConfirm(false)
          setDeleteObj({})
        }}
        onConfirm={() => {
          onDelete(deleteObj)
          setIsShowConfirm(false)
        }}
      /> */}
    </>
  )
}
